import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { capitalizeFirstLetter } from "../../../../utils/stringFunctions";
import { CreateChannelContext } from "../../../../context/CreateChannelContext";
import { ChannelState, State } from "../../../../models/SKChannel";

interface ChannelCheckListCardProps {
  index?: number;
  name?: string;
  title?: string;
  purposeText?: string;
  notes?: string;
  notesClass?: string;
  doneText?: string;
  action: () => void;
  disabled?: boolean;
  isTitleMargin?: boolean;
}

export default function ChannelCheckListCard({
  index,
  title,
  purposeText,
  notes,
  notesClass = "notes-class-content",
  doneText,
  action,
  isTitleMargin = false,
  disabled = false,
}: ChannelCheckListCardProps) {
  const [imgSrc, setImgSrc] = useState<string>(doneText ? "/icons/CheckItem.png" : "/icons/Addsign.png");

  useEffect(() => {
    setImgSrc(doneText ? "/icons/CheckItem.png" : "/icons/Addsign.png");
  }, [doneText]);

  return (
    <div className="relative w-full min-w-[200px]">
      <div className="flex items-center">
        <span>{index && <span className="content_count">{index}</span>}</span>
        {/* {name && <span className={`content_title`}>{title}</span>} */}
        {title && <span className={`content_title ${isTitleMargin ? "mb-[10px]" : ""}`}>{title}</span>}
      </div>
      {notes && <div className={notesClass}>{notes}</div>}

      <div
        id="content-item"
        className="input-content-topic"
        tabIndex={0}
        onClick={() => {
          !disabled && action();
        }}
      >
        <div className="flex items-center justify-between w-full">
          <div id="topic" className={`flex input-content-topic-text ${disabled && " !text-skgray"}`}>
            {purposeText ?? ""}
          </div>

          <div id="title" className="flex m-[15px]">
            <div className="input-content-topic-title">{doneText ?? ""}</div>
            <span className="input-plus-topic ml-[5px]">
              <img
                src={!disabled ? imgSrc : "/icons/checkeditem.png"}
                className="object-contain w-[19px] h-[20px] min-w-5"
                alt="Certification status"
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
